import { getContact, delContact, editContact } from '@/services/edm'

export default {
  namespaced: true,
  state: {
    tableSort: {},
    sortedInfo: {},
    defaultColumns: [{
      title: '名称',
      dataIndex: 'name',
      width: 400
    }, {
      title: '联系人数量',
      dataIndex: 'num',
      width: 200
    },
    {
      title: '最后更新',
      dataIndex: 'uptime',
      slots: { title: 'uptime' },
      scopedSlots: { customRender: 'uptime' },
      sorter: true,
      width: 320
    },
    {
      title: '操作',
      dataIndex: 'action',
      slots: { title: 'action' },
      scopedSlots: { customRender: 'action' },
      width: 120
    }],
    listDatas: [],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: ['10', '20', '30', '50'],
      total: 0
    },

    loading: true
  },
  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_TOTAL (state, total) {
      state.pagination.total = total
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_TABLE_SORT (state, { tableSort = {}, sorter = {} }) {
      state.tableSort = Object.assign({}, tableSort)
      state.sortedInfo = sorter
    }
  },
  getters: {
    columns (state) {
      const { defaultColumns } = state
      defaultColumns.forEach(item => {
        if (item.sorter) {
          item.sortOrder = state.sortedInfo.columnKey === item.dataIndex && state.sortedInfo.order
        }
      })
      return defaultColumns
    }
  },
  actions: {
    async fetchContact ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getContact()
      chain
        .params(params)
        .config({ tip: false })
        .onSuccess(res => {
          commit('setListDatas', res.list)
          commit('SET_TOTAL', res.count)
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async delContact ({ commit, dispatch }, params) {
      let chain = await delContact()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async editContact ({ commit, dispatch }, params) {
      let chain = await editContact()
      chain
        .params(params)
        .fetch()
      return chain
    }
  }
}
